import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../data/menuData';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('amirPizzaLang');
    return saved || 'de';
  });

  useEffect(() => {
    localStorage.setItem('amirPizzaLang', language);
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'de' ? 'en' : 'de');
  };

  const t = (key) => {
    return translations[language][key] || key;
  };

  const getLocalizedContent = (obj, field) => {
    if (!obj) return '';
    if (language === 'en') {
      return obj[`${field}_en`] || obj[field];
    }
    return obj[field];
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t, getLocalizedContent }}>
      {children}
    </LanguageContext.Provider>
  );
};